(function() {
  const ARIZONA_TIMEZONE = 'America/Phoenix';
  const CUTOFF_HOUR = 21;

  const TRANSIT_DAYS = {
    min: 2,
    max: 8
  };

  function getArizonaTime() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: ARIZONA_TIMEZONE }));
  }

  function isBusinessDay(date) {
    const day = date.getDay();
    return day !== 0 && day !== 6;
  }

  function addBusinessDays(startDate, days) {
    const result = new Date(startDate);
    let addedDays = 0;
    
    while (addedDays < days) {
      result.setDate(result.getDate() + 1);
      if (isBusinessDay(result)) {
        addedDays++;
      }
    }
    
    return result;
  }

  function formatDate(date) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${months[date.getMonth()]} ${date.getDate()}`;
  }

  function formatDateRange(startDate, endDate) {
    const startMonth = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][startDate.getMonth()];
    const endMonth = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][endDate.getMonth()];
    
    if (startMonth === endMonth) {
      return `${startMonth} ${startDate.getDate()} - ${endDate.getDate()}`;
    }
    return `${startMonth} ${startDate.getDate()} - ${endMonth} ${endDate.getDate()}`;
  }

  function calculateShippingDates() {
    const arizonaTime = getArizonaTime();
    const currentHour = arizonaTime.getHours();
    const orderDate = new Date(arizonaTime);

    const isAfterCutoff = currentHour >= CUTOFF_HOUR;
    const shipStartDays = isAfterCutoff ? 2 : 1;
    const shipEndDays = isAfterCutoff ? 3 : 2;

    const shipStartDate = addBusinessDays(orderDate, shipStartDays);
    const shipEndDate = addBusinessDays(orderDate, shipEndDays);

    const deliveryStartDate = new Date(shipStartDate);
    deliveryStartDate.setDate(deliveryStartDate.getDate() + TRANSIT_DAYS.min);
    
    const deliveryEndDate = new Date(shipEndDate);
    deliveryEndDate.setDate(deliveryEndDate.getDate() + TRANSIT_DAYS.max);

    return {
      orderDate: formatDate(orderDate),
      transitRange: formatDateRange(shipStartDate, shipEndDate),
      deliveryRange: formatDateRange(deliveryStartDate, deliveryEndDate)
    };
  }

  function initShippingEstimate() {
    const containers = document.querySelectorAll('.shipping-estimate');
    
    containers.forEach(function(container) {
      const productAvailable = container.dataset.productAvailable === 'true';
      const variantAvailable = container.dataset.currentVariantAvailable === 'true';
      
      if (!productAvailable || !variantAvailable) {
        container.style.display = 'none';
        return;
      }

      const dates = calculateShippingDates();
      
      const confirmedLabel = container.querySelector('[data-step="confirmed"]');
      const transitLabel = container.querySelector('[data-step="transit"]');
      const deliveredLabel = container.querySelector('[data-step="delivered"]');
      
      if (confirmedLabel) confirmedLabel.textContent = dates.orderDate;
      if (transitLabel) transitLabel.textContent = dates.transitRange;
      if (deliveredLabel) deliveredLabel.textContent = dates.deliveryRange;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShippingEstimate);
  } else {
    initShippingEstimate();
  }

  document.addEventListener('variant:changed', initShippingEstimate);
})();
